import React from "react";
import { useSelector, useDispatch } from "react-redux";
//internal and external components import
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import { TableRow } from "@mui/material/";
import { sortData } from "../../../common/SortSupport";
import { EnhancedTableHead } from "../../EnhancedTableHead";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { Box } from "@mui/material";
import CommentsDocsActionsIconWrapper from "../../CommentsDocsActionsIconWrapper";
import SelectBoxPrimary from "../../SelectBoxPrimary";
import { colors } from "../../../common/pallette/colors";
import {
  getCriteriaGroups,
  getEvaluationReportStandardDetails,
  getEvaluationReportStandards,
  getOffSiteStandardList,
  getSelfAssessmentCriteria,
  getStandardsEvidences,
  saveEvaluationReportStandardDetails,
  saveOffSiteEvaluation,
} from "../../../api/evaluation";
import TableSkeleton from "../../TableSkeleton";
import {
  resetEvaluation,
  resetOffSiteEvaluation,
  resetSaActions,
  resetSaComments,
  resetSaEvidences,
  resetSelectedOffSiteStandard,
  resetStandardStatuses,
  setCriteriaGroups,
  setEvalReportStandards,
  setOffSiteStandards,
  setSaCriteria,
  setSelectedOffSiteStandard,
  setSelectedSaCriteria,
} from "../../../redux/reducers/evaluation";
import OffSiteStandardsDetail from "../../../containers/StandardsDetail/OffSiteStandardsDetail";
import {
  evaluationSelectedStandardsActionsRegex,
  evaluationSelectedStandardsRegex,
  evaluationSelectedStandardsReportRegex,
  genUID,
} from "../../../common/StaticExports";
import EvalReportStandardsDetail from "../../../containers/StandardsDetail/EvalReportStandardsDetail";
import { faCircleRight } from "@fortawesome/free-regular-svg-icons";
import { useLocation, useNavigate } from "react-router";
import "./styles.css";

const OffSiteStandardsTable = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  // const currentCriteria = useSelector((state:any) => state.evaluation.selectedOffSiteCriteria);
  const currentCriteria = useSelector(
    (state: any) => state.evaluation.selectedSaCriteria
  );
  const currentClub = useSelector((state: any) => state.clubDetails);
  const standards = useSelector(
    (state: any) => state.evaluation.offSiteStandards
  );
  const offSiteEvaluation = useSelector(
    (state: any) => state.evaluation.offSiteEvaluation
  );
  const selectedERStandard = useSelector(
    (state: any) => state.evaluation.selectedERStandard
  );
  const selectedSaCriteria = useSelector(
    (state: any) => state.evaluation.selectedSaCriteria
  );
  const selctedOffSiteStandard = useSelector(
    (state: any) => state.evaluation.selctedOffSiteStandard
  );

  //supporting contents
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("uid");
  const [detail, setDetail] = React.useState(Object);
  const [detailER, setDetailER] = React.useState(Object);
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpenER, setIsOpenER] = React.useState(false);
  const [isFetching, setIsFetching] = React.useState(false);

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const fetchCriteriaStandards = async () => {
    setIsFetching(true);
    const response = await getOffSiteStandardList({
      clubId: currentClub?.id,
      criteriaId: currentCriteria?.id,
    });
    const evalReportStandards = await getEvaluationReportStandards({
      clubId: currentClub.id,
      criteriaId: currentCriteria.id,
    });
    dispatch(setEvalReportStandards(evalReportStandards));
    let migrateERList = response.map((item: any) => {
      const tempObj = evalReportStandards.find(
        (ers: any) => ers?.id == item?.id
      );
      if (tempObj != null) {
        return { ...item, evalReportStatus: tempObj?.status };
      } else {
        return item;
      }
    });
    return migrateERList;
  };
  React.useEffect(() => {
    !standards &&
      !isFetching &&
      fetchCriteriaStandards().then((res) => {
        dispatch(setOffSiteStandards(res));
        setIsFetching(false);
      });

    if (
      evaluationSelectedStandardsRegex.test(location.pathname) ||
      evaluationSelectedStandardsActionsRegex.test(location.pathname)
    ) {
      const tempsplitArr = location.pathname?.split("/");
      const tempStdId = tempsplitArr[5];
      const tempCriteriaId = tempsplitArr[1];
      // navigate(`/evaluation/criteria/${currentCriteria?.id}/standards/${tempStdId}`);
      if (!selectedSaCriteria) {
        const tempCriteriaDetails: any = {
          ...selectedSaCriteria,
          id: tempCriteriaId,
        };
        setDetail(tempCriteriaDetails);
        dispatch(setSelectedSaCriteria(tempCriteriaDetails));
      }
      if (!selctedOffSiteStandard) {
        const tempStdDetails: any = {
          ...selctedOffSiteStandard,
          id: tempStdId,
        };
        setDetail(tempStdDetails);
        dispatch(setSelectedOffSiteStandard(tempStdDetails));
      }
      setIsOpen(true);
    }
    if (evaluationSelectedStandardsReportRegex.test(location.pathname)) {
        const tempsplitArr = location.pathname?.split("/");
        const tempStdId = tempsplitArr[5];
        if (standards && standards.length > 0) {
          const tempStdDetails: any = standards.find((d: any) => d.id == tempStdId);
          setDetailER(tempStdDetails);
        } else {
          fetchCriteriaStandards().then((res) => {
            dispatch(setOffSiteStandards(res));
            const tempStdDetails: any = res.find((d: any) => d.id == tempStdId);
            setDetailER(tempStdDetails);
            setIsOpenER(true);
          });
        }
    }
  }, [currentClub, currentCriteria, location.pathname]);

  let visibleRows = React.useMemo(
    () =>
      standards && standards.length > 0 && sortData(standards, orderBy, order),
    [order, orderBy, standards]
  );

  const head = [
    {
      key: "uid",
      displayName: "id",
    },
    {
      key: "name",
      displayName: "standards",
    },
    {
      key: "",
      displayName: "",
    },
    {
      key: "",
      displayName: "star",
    },
    {
      key: "",
      displayName: "off site rating",
    },
    {
      key: "",
      displayName: "Evaluation Report",
    },
  ];

  //fetch SA Criteria
  const fetchUpdatedCriteria = async () => {
    const response = await getSelfAssessmentCriteria({
      clubId: currentClub?.id,
    });
    const groups = await getCriteriaGroups({ clubId: currentClub?.id });
    const selectedCriteria = response.find(
      (d: any) => d.id === currentCriteria?.id
    );
    dispatch(setSaCriteria(response));
    //disabled due to refresh issue in standards table
    //dispatch(setSelectedSaCriteria(selectedCriteria));
    dispatch(setCriteriaGroups(groups));
  };

  const updateState = (data: any, isEvalReport: any) => {
    const updatedData = { status: data?.status, ...data };
    if (isEvalReport) {
      const updatedList = standards.map((d: any) =>
        data?.id == d?.id ? data : d
      );
      dispatch(setOffSiteStandards(updatedList));
      getEvaluationReportStandardDetails({
        standardId: data?.id,
        clubId: currentClub.id,
      }).then((res: any) => {
        const tempUpdatedERStandard = {
          comment: res?.comment,
          actions: res?.actions,
          status: data?.evalReportStatus,
          standardId: data.id,
          clubId: currentClub.id,
        };
        saveEvaluationReportStandardDetails(tempUpdatedERStandard);
      });
    } else {
      saveOffSiteEvaluation({
        clubId: currentClub?.id,
        standardId: data?.id,
        evaluation: updatedData,
      }).then(() => {
        fetchUpdatedCriteria();
        const updatedList = standards.map((d: any) =>
          data?.id == d?.id ? data : d
        );
        dispatch(setOffSiteStandards(updatedList));
      });
    }
  };

  const manageClose = (isUpdate: any) => {
    if (!evaluationSelectedStandardsActionsRegex.test(location.pathname)) {
      setIsOpen(false);
      navigate(`/evaluation/criteria/${currentCriteria?.id}/standards`);
      dispatch(resetSelectedOffSiteStandard());
      dispatch(resetSaActions());
      dispatch(resetSaComments());
      dispatch(resetSaEvidences());
      dispatch(resetOffSiteEvaluation());
      dispatch(resetStandardStatuses());
      if (isUpdate) {
        saveOffSiteEvaluation({
          standardId: detail.id,
          clubId: currentClub.id,
          evaluation: offSiteEvaluation,
        });
      }
    }
  };

  const manageCloseER = (isUpdate: any) => {
    if (isUpdate) {
      const tempSelectedERStandard = {
        comment: selectedERStandard?.comment,
        actions: selectedERStandard?.actions,
        status: selectedERStandard?.status,
        standardId: detailER.id,
        clubId: currentClub.id,
      };
      saveEvaluationReportStandardDetails(tempSelectedERStandard);
    }
    setIsOpenER(false);
    navigate(`/evaluation/criteria/${currentCriteria?.id}/standards`);
  };

  //table contents
  return (
    <React.Fragment>
      <Box sx={{ position: "relative" }}>
        <OffSiteStandardsDetail isOpen={isOpen} handleClose={manageClose} />
        <EvalReportStandardsDetail
          isOpen={isOpenER}
          detail={detailER}
          handleClose={manageCloseER}
        />
        <TableContainer sx={{ overflowY: "auto" }}>
          <Table stickyHeader size="small" aria-label="a dense table">
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              tableHeads={head ? head : []}
            />
            <TableBody>
              {!isFetching && visibleRows && visibleRows?.length ? (
                visibleRows?.map((d: any, i: number) => (
                  <TableRow
                    className="hoverBG"
                    sx={{ cursor: "pointer" }}
                    key={`standards-table-row-${i}`}
                  >
                    <TableCell className="fs12">{genUID(d.uid)}</TableCell>
                    <TableCell
                      className="fs12 standardsNameCell"
                      onClick={() => {
                        navigate(
                          `/evaluation/criteria/${currentCriteria?.id}/standards/${d?.id}`
                        );
                        setDetail(d);
                        dispatch(setSelectedOffSiteStandard(d));
                        setIsOpen(!isOpen);
                      }}
                    >
                      {d.name}
                    </TableCell>
                    <TableCell className="fs12" sx={{ minWidth: 180 }}>
                      <CommentsDocsActionsIconWrapper
                        actions={d.noOfActions}
                        comments={d.noOfComments}
                        docs={d.noOfEvidences}
                        showDetailedCount={true}
                        jlComments={d.noOfJLComments}
                        clubComments={d.noOfClubComments}
                      />
                    </TableCell>
                    <TableCell className="fs12">
                      {Array.from({ length: d.starRating }, () => (
                        <FontAwesomeIcon
                          icon={faStar}
                          style={{ color: colors.yellow.bright }}
                        />
                      ))}
                    </TableCell>
                    <TableCell className="fs12">
                      <SelectBoxPrimary
                        label={""}
                        report={"siteReview"}
                        options={[0, 1, 2, 3]}
                        isStatus={true}
                        manageChange={(e: any) => {
                          updateState({ ...d, status: e }, false);
                        }}
                        selected={d?.status}
                        leftPosition={"85% !important"}
                      />
                    </TableCell>
                    <TableCell className="fs12" sx={{ display: "flex" }}>
                      <SelectBoxPrimary
                        label={""}
                        report={"siteReview"}
                        options={[0, 1, 2, 3]}
                        isStatus={true}
                        manageChange={(e: any) => {
                          updateState({ ...d, evalReportStatus: e }, true);
                        }}
                        selected={d?.evalReportStatus}
                        leftPosition={"85% !important"}
                      />
                      <FontAwesomeIcon
                        className="ml10 selectedBlue fs20 cursorPointer"
                        onClick={() => {
                          setDetailER(d);
                          setIsOpenER(!isOpenER);
                          navigate(`/evaluation/criteria/${currentCriteria?.id}/standards/${d?.id}/evaluationreports`);
                        }}
                        icon={faCircleRight}
                      />
                    </TableCell>
                  </TableRow>
                ))
              ) : !visibleRows && !isFetching ? (
                <TableRow>
                  <TableCell colSpan={head?.length}>
                    {"NO RECORDS FOUND"}
                  </TableCell>
                </TableRow>
              ) : (
                isFetching && (
                  <TableSkeleton rowCount={8} cellCount={head?.length} />
                )
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </React.Fragment>
  );
};

export default OffSiteStandardsTable;
